<template>
  <div class="modalWrapper" :class="{ animate: animate }" v-if="visible">
    <div
      class="modalBlock"
      :class="{ animate: animate }"
      id="selectMenuModalBlock"
    >
      <div class="headerWrapper">
        <div class="actionHeadline">
          {{
            getTranslation(
              $store,
              "Menu",
              "question_text",
              activeCombo.id,
              activeCombo.question_text
            )
          }}
        </div>
      </div>
      <div class="selectMenuWrapper">
        <div class="selectMenuOptions">
          <div class="selectMenuBlock" @click="confirm(product)">
            <div class="menuImage">
              <img :src="menuImage" />
            </div>
            <div class="menuSubText">
              {{
                getTranslation(
                  $store,
                  "Menu",
                  "subtext",
                  activeCombo.id,
                  activeCombo.subtext
                )
              }}
            </div>
            <div class="selectMenuBlockAction">
              <confirm-button
                @onConfirm="confirm(product)"
                :text="$t('combo.btn.get_combo')"
                width="100%"
              />
            </div>
          </div>
          <div class="denyMenuBlock" @click="deny()">
            <div class="productImage">
              <img :src="productImage" style="width: 300px" />
            </div>
            <div class="menuSubText">
              {{ $t(`combo.deny_combo`, { name: this.product_display_name }) }}
            </div>
            <div class="denyMenuBlockAction">
              <deny-button
                @onDeny="deny()"
                :text="$t('combo.btn.deny_combo')"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="actionWrapper">
        <div class="confirmActions">
          <deny-button
            @onDeny="close()"
            :text="$t('dialog.attribute.btn.deny')"
            width="190px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toCalculatable, toPrintable } from "@/utils/pricing";
import {
  generate_random_string,
  getPotentialMenus,
  getTranslatedMenuName,
  getTranslation,
  opacityAnimation
} from "@/utils/helpers";
import { SelectMenuModalPlugin } from "@/plugins/uimodal.plugin";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ConfirmButton from "@/components/modals/common/confirmButton.vue";
import DenyButton from "@/components/modals/common/denyButton.vue";
import { cloneDeep, isEmpty } from "lodash";

import {
  combineProductsToMenu,
  createNewObject,
  findSameBasketItem,
  productToBasketItem
} from "@/utils/products";

export default {
  components: { DenyButton, ConfirmButton },
  data() {
    return {
      visible: false,
      activeComponent: {},
      product: {},
      product_display_name: "",
      assignedProductAttributes: [],
      onConfirm: {},
      animate: true
    };
  },
  computed: {
    productImage() {
      if (
        this.product.selectedSize &&
        this.product.selectedSize.alternate_picture
      ) {
        return this.product.selectedSize.alternate_picture;
      }
      return this.product.image;
    },
    menuImage() {
      let menu_image = require("@/assets/img/burger_menu.png");
      if (this.activeCombo.components[0].selected) {
        const mainItem = this.activeCombo.components[0].selected;
        this.activeCombo.product_ids.forEach(elem => {
          if (elem.id === mainItem.id) {
            if (elem.menu_preview) {
              menu_image = elem.menu_preview;
            }
          }
        });
      }
      return menu_image;
    },
    availableSizesSorted() {
      return this.product.available_sizes
        .slice()
        .sort((a, b) => a.order_by - b.order_by);
    },
    ...mapGetters({
      activeCombo: "ACTIVE_COMBO",
      products: "PRODUCTS",
      menus: "MENUS",
      basket: "BASKET"
    })
  },
  methods: {
    ...mapActions({
      logRouter: "LOG_ROUTER",
      logAudit: "LOG_AUDIT"
    }),
    ...mapMutations({
      setActiveCombo: "SET_ACTIVE_COMBO",
      setBasket: "SET_BASKET"
    }),
    toPrintable,
    getTranslation,
    displayPrice(size) {
      let price = toCalculatable(this.itemSizePrice(size));
      let offset = toCalculatable(size.offset_price);
      if (price + offset === 0.0) return "";
      if (this.menuOffset) {
        if (offset === 0.0) {
          return "";
        }
        return toPrintable(offset, true);
      }
      return toPrintable(price + offset);
    },
    hide() {
      this.visible = false;
    },
    close() {
      console.log("close");
      this.hide();
    },
    deny() {
      console.log("deny");
      // TODO NOT DRY SEE RequestCombo.vue
      this.addBasket();
      this.hide();
    },
    confirm(product) {
      console.log("confirm");
      if (typeof this.onConfirm === "function") {
        this.onConfirm(product);
        this.hide();
      } else {
        this.selectComboAnimation();
      }
    },
    show(params) {
      this.visible = true;
      this.animate = params.animate;
      this.product = params.menu.components[0].selected;
      if (!isEmpty(this.product)) {
        if (!isEmpty(this.product.selectedSize)) {
          this.product_display_name = getTranslation(
            this.$store,
            "Size",
            "display_name",
            this.product.selectedSize.id,
            this.product.selectedSize.name
          );
        } else {
          this.product_display_name = getTranslation(
            this.$store,
            "Product",
            "display_name",
            this.product.id,
            this.product.name
          );
        }
      }
      this.onConfirm = params.onConfirm;
    },
    setActiveComponent(menu) {
      if (menu.components[1]) {
        let payload = { id: menu.components[1].id };
        this.$emit("changeComponent", payload);
      }
    },
    selectCombo() {
      console.log("selectCombo");
      const newActive = {
        ...this.activeCombo,
        selectedCombo: true,
        needAsk: false
      };
      this.logAudit({
        category: "COMBO",
        event: "CREATED",
        data: newActive
      });
      this.setActiveCombo(newActive);
      this.hide();
      this.logRouter({ name: "combo", router: this.$router });
    },
    selectComboAnimation() {
      console.log("selectComboAnimation");
      const opacityConfig = {
        from: 1,
        to: 0,
        step: -0.1
      };
      opacityAnimation("selectMenuModalBlock", opacityConfig, this.selectCombo);
    },
    addBasket() {
      // TODO NOT DRY SEE RequestCombo.vue
      const basketItem = this.activeCombo.components[0].selected;
      const product = this.products.find(elem => elem.id === basketItem.id);
      // handle several possible menus
      if (product && product.menus && product.menus.length > 1) {
        const potential_menus = getPotentialMenus(
          this.menus,
          product.menus,
          false
        );
        if (potential_menus.length > 1) {
          const menu = cloneDeep(potential_menus[1]);
          const menuItem = productToBasketItem(product);
          if (this.activeCombo.components[0].selected.ingredients) {
            menuItem.ingredients = createNewObject(
              this.activeCombo.components[0].selected.ingredients
            );
          }
          if (this.activeCombo.components[0].selected.selectedSize) {
            menuItem.selectedSize = createNewObject(
              this.activeCombo.components[0].selected.selectedSize
            );
          }
          if (this.activeCombo.components[0].selected.selectedExtras) {
            menuItem.selectedExtras = createNewObject(
              this.activeCombo.components[0].selected.selectedExtras
            );
          }
          menu.components[0].selected = menuItem;
          menu.name = getTranslatedMenuName(this.$store, menu);
          menu.needAsk = true;
          menu.selectedCombo = true;
          menu.uid = generate_random_string(16);

          this.setActiveCombo(menu);
          this.setActiveComponent(menu);
          this.selectCombo();
          return;
        }
      }
      if (basketItem) {
        let existing = findSameBasketItem(basketItem, this.basket);
        if (existing) {
          existing.count += 1;
          let newBasket = combineProductsToMenu(this.menus, this.basket);
          this.setBasket(newBasket);
        } else {
          let newBasket = [basketItem, ...this.basket];
          newBasket = combineProductsToMenu(this.menus, newBasket);
          this.setBasket(newBasket);
        }
        this.logAudit({
          category: "CART",
          event: "ADD_PRODUCT",
          data: basketItem
        });
      }
      if (this.basket && this.basket.length >= 1) {
        this.logRouter({ name: "order", router: this.$router });
      } else {
        this.logRouter({ name: "menu", router: this.$router });
      }
    }
  },
  beforeMount() {
    // listen to emitted event "show", see uimodal.plugin.js
    SelectMenuModalPlugin.EventBus.$on("show", params => {
      this.show(params);
    });
    SelectMenuModalPlugin.EventBus.$on("hide", () => {
      this.hide();
    });
  }
};
</script>
<style lang="scss" scoped>
@keyframes modalBlockIn {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes modalWrapperOut {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.selectMenuWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row;
}
.selectMenuOptions {
  display: flex;
  justify-content: space-between;
  width: 910px;
}
.selectMenuBlock,
.denyMenuBlock {
  background: #fff;
  border-radius: 15px;
  box-shadow: 3px 3px 20px #00000014;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  padding-top: 20px;
  width: 435px;
  .menuImage,
  .productImage {
    display: flex;
    width: 100%;
    min-height: 310px;
    img {
      width: 400px;
      height: 250px;
      margin: 45px auto 20px;
      object-fit: contain;
      justify-content: flex-end;
    }
  }
  .menuSubText {
    display: flex;
    justify-content: center;
    flex: auto;
    font-family: var(--app_font-family-light);
    font-size: 18px;
    padding: 0 40px 30px 40px;
  }
}
.selectMenuBlockAction,
.denyMenuBlockAction {
  display: flex;
  justify-content: flex-end;
  padding: 0 40px 30px 40px;
  width: 435px;
}

.confirmActions {
  display: flex;
  justify-content: center;
  padding: 50px 0 0 0;
  width: 910px;
}

.modalWrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: flex-start;
  background-color: rgba(0, 0, 0, 0.5);
}

.modalWrapper.animate {
  /*animation: modalWrapperOut 0ms forwards ease;*/
}

.modalBlock {
  align-self: flex-start;
  box-shadow: 0 0 50px #00000029;
  color: black;
  border-radius: var(
    --component_modals_common_productAttributes_modalBlock_border-radius
  );
  background: var(
    --component_modals_common_productAttributes_modalBlock_background
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 335px 0 0 0;
  padding: 50px 20px 40px 20px;
  text-align: center;
  width: 95vw;
  z-index: 1300;
}

.modalBlock.animate {
  animation: modalBlockIn 500ms forwards ease;
}

.actionWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}

.headerWrapper {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}

.actionHeadline {
  color: var(--component_modals_common_productAttributes_actionHeadline_color);
  font-family: var(
    --component_modals_common_productAttributes_actionHeadline_font-family
  );
  font-size: var(
    --component_modals_common_productAttributes_actionHeadline_font-size
  );
  text-align: center;
  text-transform: var(
    --component_modals_common_productAttributes_actionHeadline_text-transform
  );
  width: 910px;
  margin-bottom: 40px;
}
</style>
